import atsReducer from 'modules/ATS/reducer.js'
import authReducer from 'modules/Auth/reducers'
import coursesReducer from 'modules/Courses/reducers'
import dashboardReducer from 'modules/Dashboard/reducers'
import driveReducer from 'modules/Drive/reducers'
import driveInfo from 'modules/DriveInfo/reducers'
import EventReducer from 'modules/Events/reducers'
import jobRolePreviewReducer from 'modules/JobPreview/reducer'
import jobRoleReducer from 'modules/JobRoles/NewJobRole/reducers'
import manageReducers from 'modules/ManageProfile/reducers'
import PlacementReducer from 'modules/Placement/reducer'
import roleReducer from 'modules/Roles/reducers'
import ruleEngineReducer from 'modules/RuleEngine/reducers'
import settingsReducers from 'modules/Settings/reducers'
import instituteReducer from 'modules/Students/reducers'
import topDashboardReducer from 'modules/TPODashboard/reducers'
import userReducers from 'modules/Users/reducers'
import tpoRequestReducer from 'modules/TPORequests/reducers'
import { combineReducers } from 'redux'
import tpoReducer from '../redux/Slices/tpoSlice'
import SubscribedInstitutes, { MediaState } from '../modules/Assessment/reducers.js'
import onboardingReducer from 'modules/OnBoarding/reducer'
import { Tooltip } from 'antd'

export default combineReducers({
  auth: authReducer,
  institute: instituteReducer,
  roles: roleReducer,
  drives: driveReducer,
  user: userReducers,
  manage: manageReducers,
  rules: ruleEngineReducer,
  courses: coursesReducer,
  settings: settingsReducers,
  driveInfo: driveInfo,
  dashboard: dashboardReducer,
  jobRole: jobRoleReducer,
  ats: atsReducer,
  jobRolesPreview: jobRolePreviewReducer,
  placement: PlacementReducer,
  event: EventReducer,
  tpoDashboard: topDashboardReducer,
  tpoRequest: tpoRequestReducer,
  tpo: tpoReducer,
  SubscribedInstitutes: SubscribedInstitutes,
  mediaState: MediaState,
  studentData: onboardingReducer,
})
